<template>
  <v-container
    style="margin: 0px; padding: 0px; max-width: 100%; vertical-align: top"
  >
    <v-card>
      <v-card-title>
        <ent-workflow-nav-bar
          :args="navConfig"
          :buttonclick.sync="navbuttons"
          :key="navreload"
        >
        </ent-workflow-nav-bar>
      </v-card-title>
      <v-card-text>
        <v-row no-gutters dense>
          <v-col v-if="show_edit" cols="12" md="2" sm="12">
            <search-config
              :args="searchConfig"
              :selection.sync="edit_id"
            ></search-config>
          </v-col>
          <v-col v-if="show_welcome">
            <ent-workflow-welcome :args="getDescription">
            </ent-workflow-welcome>
          </v-col>
          <v-col v-if="show_main" cols="12" md="10" sm="12">
            <metrc-global-pref
              :args="main_args"
              :finished.sync="main_finish"
              :save_enable.sync="save_enable"
              ref="main_section"
              :key="main_key"
            ></metrc-global-pref>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
  import { sync } from "vuex-pathify";
  import MetrcGlobalPref from "@/../../cortex/src/views/MetrcGlobalPref.vue";
  import SearchConfig from "@/../../library/view/EntSearchConfig.vue";
  import EntWorkflowWelcome from "@/../../library/view/EntWorkflowWelcome.vue";
  import EntNavButtonRow from "@/../../library/view/EntNavButtonRow.vue";
  import EntWorkflowNavBar from "@/../../library/view/EntWorkflowNavBar.vue";
  import metrcPrefUtils from "@/../../cortex/src/services/metrcpref.js";
  import navButtonUtils from "@/../../library/mixins/navbuttons.js";
  import helpUtils from "@/../../library/mixins/help.js";

  export default {
    components: {
      EntWorkflowWelcome,
      EntNavButtonRow,
      MetrcGlobalPref,
      SearchConfig,
      EntWorkflowNavBar,
    },
    mixins: [metrcPrefUtils, navButtonUtils, helpUtils],
    props: ["args"],
    data: () => ({
      // Panel swiches
      show_welcome: false,
      show_main: false,
      show_edit: false,

      // Main panel settings
      main_args: {},
      main_key: 0,
      main_finish: null,

      // Edit panel settings
      edit_id: null,
      searchConfig: { panelTitle: "edit_select", selectLabel: "pref" },
    }),
    computed: {
      // Sync with variables from the store
      userlang: sync("misc/language"),
      phrases: sync("misc/phraseMap"),
      loader: sync("login/loader"),
      dark: sync("misc/dark"),

      // Get the description to fill in the welcome section
      getDescription() {
        if (!this.show_edit) return this.args.desc;
        else return ""
      },
    },
    watch: {
      edit_id() {
        console.log(`Edit Selection Received: `, this.edit_id);
        this.loadEditForm();
      },
      save_enable() {
        console.log(`Save Enable status updated`);
        this.updateNavigation();
      },
    },
    methods: {
      configureWorkflow() {
        this.enableAllNavButtons();
        let defaultStyle = "vertical-align: top";
        if (this.args.hasOwnProperty("popup")) {
          if (!this.args.hasOwnProperty("item")) this.newForm();
          else {
            this.edit_id = this.args.item;
            this.editForm();
          }
        } else {
          this.main_args.style = defaultStyle;
          this.welcomeForm();
        }
      },
      welcomeForm() {
        console.log(`Setting up the welcome form for the workflow`);
        this.hasNew = true;
        this.hasEdit = true;
        this.hasCancel = false;
        this.hasSave = false;
        this.save_enable = false;
        this.hasClose = true;
        this.show_welcome = true;
        this.show_edit = false;
        this.show_main = false;
        this.updateNavigation();
      },
      newForm() {
        console.log(`Processing the actions after a new form entry`);
        this.hasNew = false;
        this.hasEdit = false;
        this.hasSave = true;
        this.save_enable = false;
        this.hasCancel = true;
        this.hasClose = false;
        this.show_welcome = false;
        this.show_main = true;
        this.show_edit = false;
        this.main_args.item = null;
        this.main_key++;
        this.updateNavigation();
      },
      editForm() {
        console.log(`Processing a request for an edit form`);
        this.hasNew = false;
        this.hasEdit = false;
        this.hasSave = true;
        this.save_enable = false;
        this.hasCancel = true;
        this.hasClose = false;
        this.show_welcome = true;
        this.show_main = false;
        this.show_edit = true;
        this.searchConfig.cb = this.getGlobalPrefList;
        this.searchConfig.cb_name = "code";
        this.updateNavigation();
      },
      clearEditForm() {
        console.log(`In the Clear Edit Form Function`)
        this.edit_id = null
      },
      loadEditForm() {
        if(this.edit_id === null) return
        this.main_args.item = this.edit_id;
        this.main_key++;
        this.show_main = true;
        this.show_welcome = false;
        this.updateNavigation();
      },
      async save() {
        await this.$refs.main_section.save();
        this.edit_id = null
        if(!this.args.howOwnProperty("popup")) this.welcomeForm()
        else this.closeWorkflow()
      },
    },
    mounted() {
      console.log(`Mount Arguments = `, this.args);
      this.configureWorkflow();
    },
  };
</script>
<style scoped>
  .compact-form {
    transform: scale(0.95);
    transform-origin: top;
  }
  .card-outter {
    padding-bottom: 50px;
  }
  .card-actions {
    position: absolute;
    bottom: 0;
  }
  .flexcard {
    display: flex;
    flex-direction: column;
  }
</style>
